// Selectors for ncodes
export const selectNcodesData = (state) => state.tool.ncodes.data;
export const selectNcodesLoading = (state) => state.tool.ncodes.loading;
export const selectNcodesError = (state) => state.tool.ncodes.error;

// Selectors for result
export const selectResultData = (state) => state.tool.result.data;
export const selectResultLoading = (state) => state.tool.result.loading;
export const selectResultError = (state) => state.tool.result.error;

// Selectors for quiz submit
export const selectQuizSubmitData = (state) => state.tool.quizSubmit.data;
export const selectQuizSubmitLoading = (state) => state.tool.quizSubmit.loading;
export const selectQuizSubmitError = (state) => state.tool.quizSubmit.error;

export const selectPersonalityOptionsData = (state) => state.tool.personalityOptions.data;
export const selectPersonalityOptionsLoading = (state) => state.tool.personalityOptions.loading;
export const selectPersonalityOptionsError = (state) => state.tool.personalityOptions.error;

export const selectPersonalitySubmitData = (state) => state.tool.personalitySubmit.data;
export const selectPersonalitySubmitLoading = (state) => state.tool.personalitySubmit.loading;
export const selectPersonalitySubmitError = (state) => state.tool.personalitySubmit.error;

export const selectInnerNeedsSubmitData = (state) => state.tool.innerNeedsSubmit.data;
export const selectInnerNeedsSubmitLoading = (state) => state.tool.innerNeedsSubmit.loading;
export const selectInnerNeedsSubmitError = (state) => state.tool.innerNeedsSubmit.error;

// Selectors for trait test submit
export const selectTraitTestSubmitData = (state) => state.tool.traitTestSubmit.data;
export const selectTraitTestSubmitLoading = (state) => state.tool.traitTestSubmit.loading;
export const selectTraitTestSubmitError = (state) => state.tool.traitTestSubmit.error;

// ✅ NEW: Selectors for token expiry
export const selectTokenExpiryCheckData = (state) => state.tool.tokenExpiryCheck.data;
export const selectTokenExpiryCheckLoading = (state) => state.tool.tokenExpiryCheck.loading;
export const selectTokenExpiryCheckError = (state) => state.tool.tokenExpiryCheck.error;

// Selectors for reorder baselines
export const selectReorderBaselinesData = (state) => state.tool.reorderBaselines.data;
export const selectReorderBaselinesLoading = (state) => state.tool.reorderBaselines.loading;
export const selectReorderBaselinesError = (state) => state.tool.reorderBaselines.error;

// Selectors for prospect submission
export const selectProspectSubmitData = (state) => state.tool.prospectSubmit.data;
export const selectProspectSubmitLoading = (state) => state.tool.prospectSubmit.loading;
export const selectProspectSubmitError = (state) => state.tool.prospectSubmit.error;

// Combined selectors
export const selectToolState = (state) => state.tool;